import React from "react";
import { Helmet } from "@dr.pogodin/react-helmet";

export const meta = {
  slug: "what-is-qbi",
  title: "What Is the QBI Deduction? Guide for 1099 Workers",
  description: "A simple explanation of the Qualified Business Income (QBI) deduction: who qualifies and how it's calculated.",
  date: "2025-01-10",
  tags: ["tax deductions", "QBI", "1099"]
};

export default function WhatIsQBI() {
  return (
    <main className="max-w-3xl mx-auto px-6 md:px-8 py-10">
      <Helmet>
        <title>What Is the QBI Deduction? | Free1099Calc</title>
        <meta
          name="description"
          content="A simple explanation of the Qualified Business Income (QBI) deduction: who qualifies and how it’s calculated."
        />
      </Helmet>

      <h1 className="text-3xl font-bold mb-6">
        What Is the Qualified Business Income (QBI) Deduction?
      </h1>
      <p className="text-slate-700 mb-4">
        The QBI deduction allows many pass-through businesses to deduct up to 20% of qualified
        business income. It’s limited by income thresholds and special rules for certain service
        businesses.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Who qualifies?</h2>
      <p className="text-slate-700">
        Most sole proprietorships, partnerships, and S-Corps with domestic income may qualify,
        subject to limitations at higher income levels.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">How it’s calculated</h2>
      <p className="text-slate-700">
        In general, up to 20% of qualified business income, capped by your taxable income and
        affected by W-2 wages and qualified property. Complex cases should be reviewed with a CPA.
      </p>
    </main>
  );
}
